import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import HomeBanner from "../components/home/HomeBanner";
import { Helmet } from "react-helmet";

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="whatsapp services,
                  sms services,
                  social media marketing,
                  digital marketing,
                  whatsapp marketing,
                  whatsapp marketing services,
                  digital marketing services,
                  whatsapp api provider,
                  digital marketing company,
                  whatsapp business marketing,
                  digital marketing agency,
                  sms marketing services,
                  bulk sms marketing,
                  sms marketing platform,
                  sms platform,
                  online marketing strategy,
                  bulk sms service provider,
                  social media marketing services,
                  facebook digital marketing,
                  social media digital marketing,
                  online marketing services Chennai,
                  online marketing services India,
                  online business promotion Chennai,
                  online business promotion India"
          />
      </Helmet>
      <Navbar />
      <HomeBanner />
      <Footer />
    </>

  );
};

export default Home;
